import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "../../../components/Modal/Modal";
import { uploadEventsFile } from "../../../services/eventServices";
import { FaUpload, FaTimes } from "react-icons/fa";

export default function UploadEventsModal({ isOpen, onClose, onUploaded }) {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  if (!isOpen) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (!file) return;
    setUploading(true);
    try {
      await uploadEventsFile(file);
      onUploaded?.();
      onClose();
    } finally {
      setUploading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} labelledById="upload-events-title">
      <ModalHeader
        id="upload-events-title"
        title="Importer des événements"
        subtitle="Fichier CSV / Excel export Ligue"
        onClose={onClose}
      />
      <ModalBody>
        <form onSubmit={submit} className="space-y-4">
          <input
            type="file"
            accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            onChange={(e) => setFile(e.target.files?.[0] || null)}
          />
          <p className="text-sm text-slate-500">
            Formats supportés : CSV, XLS, XLSX
          </p>
          <ModalFooter>
            <button
              type="button"
              onClick={onClose}
              className="inline-flex items-center gap-2 px-4 h-10 rounded-lg bg-slate-100 text-slate-800 hover:bg-slate-200"
            >
              <FaTimes /> Annuler
            </button>
            <button
              type="submit"
              disabled={!file || uploading}
              className="inline-flex items-center gap-2 px-4 h-10 rounded-lg bg-emerald-600 text-white hover:bg-emerald-700 disabled:opacity-60"
            >
              <FaUpload /> {uploading ? "Import…" : "Importer"}
            </button>
          </ModalFooter>
        </form>
      </ModalBody>
    </Modal>
  );
}
